import {FormBuilderAnswerableToggle, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'
import ToggleWithIcon from "@/Components/TailwindUI/Form/ToggleWithIcon";
import {useState} from "react";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableToggle<T extends { answerable: FormBuilderAnswerableToggle }>({
                                                                                                    question,
                                                                                                    data,
                                                                                                    setData,
                                                                                                    hasError,
                                                                                                    settings
                                                                                                }: Props) {

    // check if the default is null and convert it to a string because React doesn't like null

    return (
        <div className="relative mt-1">
            <ToggleWithIcon enabled={!(data[question.id] === undefined || data[question.id] === '0' || data[question.id] === false)} setEnabled={() => {
                setData(question.id, (data[question.id] === undefined || data[question.id] === '0' || data[question.id] === false))
            }} settings={settings}/>
            {(hasError) ? (errorBadge()) : (<></>)}
        </div>
    );

}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}
